import { cn } from '@utils/cn';

import type { PaginationDotsProps } from './PaginationDots.types';

import { dotClasses, paginationDotsVariants } from './PaginationDots.styles';

const PaginationDots = ({
  total,
  activeIndex,
  onDotSelect,
  className,
  ...props
}: PaginationDotsProps) => {
  return (
    <div
      className={cn(paginationDotsVariants, className)}
      role="navigation"
      aria-label="Pagination"
      {...props}
    >
      {Array.from({ length: total }, (_, index) => {
        const isActive = index === activeIndex;

        return (
          <div
            key={index}
            className={cn(
              dotClasses({
                state: isActive ? 'active' : 'inactive'
              })
            )}
            role="button"
            tabIndex={0}
            aria-label={`Go to slide ${index + 1}`}
            aria-current={isActive ? 'true' : undefined}
            onClick={() => onDotSelect?.(index)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onDotSelect?.(index);
              }
            }}
          />
        );
      })}
    </div>
  );
};

export { PaginationDots };
